import React, { useState, Suspense } from 'react';
import {
  Menu,
  Layout,
  Avatar,
  Dropdown,
  Modal,
  Button,
  Result,
  Tooltip,
} from 'antd';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  Link,
  useLocation,
} from 'react-router-dom';
import { useDelete } from '../hooks/useDelete';
import { ProfileDrawerComponent } from './ProfileDrawerComponent';
import { logout } from '../dist/functions/auth';
import useFetchPermissionSets from '../hooks/useFetchPermissions';
import useFetchIfhasMenuAccess from '../hooks/useFetchIfhasMenuAccess';
import {
  permissionsList,
  createDefaultPermissionSet,
} from '../dist/statics/permission_directory';
import {
  SettingOutlined,
  HomeOutlined,
  BankOutlined,
  BuildOutlined,
  LogoutOutlined,
  ProfileOutlined,
  ExclamationCircleOutlined,
  UserOutlined,
  CloudUploadOutlined,
  PieChartOutlined,
  DollarCircleOutlined,
  SettingFilled,
  FileDoneOutlined,
  SendOutlined,
  LeftOutlined,
} from '@ant-design/icons';
import '../MenuComponent.css';
import './appShell.css';
import useIsMobile from '../hooks/useIsMobile';
import logo from '../dist/images/automart_logo_square_transparent_256.png';
import { routesConfig } from 'dist/statics/routes';
import { isLogin } from 'dist/functions/auth';
import { LoginComponent } from './LoginComponent';

const { Header, Footer, Sider, Content } = Layout;
const { SubMenu } = Menu;
const { confirm } = Modal;

const initialRolesRestriction = createDefaultPermissionSet();

export const MenuComponent = (props) => {
  const [, setPermissions] = useState([]);
  const [collapsed, setCollapsedMode] = useState(false);
  const [showDrawer, setDrawerStatus] = useState(false);
  const rolesRestriction = useFetchPermissionSets(
    permissionsList,
    initialRolesRestriction,
  );

  const {
    CLOSE_AUCTIONS_BY_BANK,
    CLOSE_AUCTIONS_BY_FILE,
    REVIEW_GROUP_CREATE,
    REVIEW_GROUP_UPDATE,
    REVIEW_GROUP_DELETE,
    REVIEW_GROUP_RESTORE,
    REVIEW_INDEX_CREATE,
    REVIEW_INDEX_UPDATE,
    REVIEW_INDEX_DELETE,
    REVIEW_INDEX_RESTORE,
    CREATE_REMARKS_SUB_GROUP,
    UPDATE_REMARKS_SUB_GROUP,
    DELETE_REMARKS_SUB_GROUP,
    RESTORE_REMARKS_SUB_GROUP,
    CREATE_REMARKS_INDEX,
    UPDATE_REMARKS_INDEX,
    DELETE_REMARKS_INDEX,
    RESTORE_REMARKS_INDEX,
  } = rolesRestriction;

  const reviewGroupPermissionSet = [
    REVIEW_GROUP_CREATE,
    REVIEW_GROUP_UPDATE,
    REVIEW_GROUP_DELETE,
    REVIEW_GROUP_RESTORE,
  ];

  const reviewGroupHasAccess = useFetchIfhasMenuAccess(
    reviewGroupPermissionSet,
  );

  const reviewIndexPermissionSet = [
    REVIEW_INDEX_CREATE,
    REVIEW_INDEX_UPDATE,
    REVIEW_INDEX_DELETE,
    REVIEW_INDEX_RESTORE,
  ];

  const reviewIndexHasAccess = useFetchIfhasMenuAccess(
    reviewIndexPermissionSet,
  );

  const remarksSubGroupPermissionSet = [
    CREATE_REMARKS_SUB_GROUP,
    UPDATE_REMARKS_SUB_GROUP,
    DELETE_REMARKS_SUB_GROUP,
    RESTORE_REMARKS_SUB_GROUP,
  ];

  const remarksSubGroupHasAccess = useFetchIfhasMenuAccess(
    remarksSubGroupPermissionSet,
  );

  const remarksIndexPermissionSet = [
    CREATE_REMARKS_INDEX,
    UPDATE_REMARKS_INDEX,
    DELETE_REMARKS_INDEX,
    RESTORE_REMARKS_INDEX,
  ];

  const remarksIndexHasAccess = useFetchIfhasMenuAccess(
    remarksIndexPermissionSet,
  );

  const handleClick = () => {};

  const toggle = () => {
    setCollapsedMode(!collapsed);
  };

  const OnConfirm = async () => {
    confirm({
      title: 'Do you Want to Logout?',
      icon: <ExclamationCircleOutlined />,
      content: 'all unfinished tasks, will be discarded after signing out',
      onOk() {
        Logout();
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  const Logout = async () => {
    await useDelete(
      `${
        process.env.REACT_APP_API_URL
      }/authentications/tokens/${localStorage.getItem('token')}`,
    );
    localStorage.clear();
    logout();
    window.location.reload();
  };

  const showProfile = () => {
    setDrawerStatus(!showDrawer);
  };

  function handleMenuClick(e) {}

  if (!isLogin()) {
    if (window.location.pathname === '/nps') {
      const NPSPublic = React.lazy(() =>
        import('components/modules/NPSByAdviserComponent').then((m) => ({
          default: m.NPSByAdviserComponent,
        })),
      );
      return (
        <React.Suspense fallback={<div>Loading…</div>}>
          <NPSPublic />
        </React.Suspense>
      );
    }
    return <LoginComponent setPermissions={setPermissions} />;
  }

  return (
    <Router>
      <Layout className="app-root">
        <ActiveMenu
          collapsed={collapsed}
          toggle={toggle}
          handleClick={handleClick}
          reviewIndexHasAccess={reviewIndexHasAccess}
          reviewGroupHasAccess={reviewGroupHasAccess}
          remarksSubGroupHasAccess={remarksSubGroupHasAccess}
          remarksIndexHasAccess={remarksIndexHasAccess}
          rolesRestriction={rolesRestriction}
          CLOSE_AUCTIONS_BY_FILE={CLOSE_AUCTIONS_BY_FILE}
          CLOSE_AUCTIONS_BY_BANK={CLOSE_AUCTIONS_BY_BANK}
          onShowProfile={showProfile}
          onLogout={OnConfirm}
        />
        <Layout className="app-main-layout">
          <Header className="app-header">
            <div
              id="app-header-slot"
              className="app-header-slot"
              data-testid="app-header-slot"
            />
            <div className="app-header-user">
              <div className="app-header-user-text">
                <span className="app-header-user-name">
                  {localStorage.getItem('name')}
                </span>
                <span className="app-header-user-role">
                  {localStorage.getItem('role_name')}
                </span>
              </div>
              <Dropdown
                trigger={['click']}
                placement="bottomRight"
                overlay={
                  <Menu onClick={handleMenuClick}>
                    <Menu.Item
                      key="1"
                      icon={<ProfileOutlined />}
                      onClick={showProfile}
                    >
                      View Profile
                    </Menu.Item>
                    <Menu.Item
                      key="2"
                      icon={<LogoutOutlined />}
                      onClick={OnConfirm}
                    >
                      Logout
                    </Menu.Item>
                  </Menu>
                }
              >
                <button
                  type="button"
                  className="app-header-avatar"
                  aria-label="Account menu"
                  data-testid="app-header-avatar"
                >
                  <Avatar
                    className="app-avatar"
                    size={32}
                    icon={<UserOutlined />}
                  />
                </button>
              </Dropdown>
            </div>
          </Header>
          <Content className="app-content">
            <div className="app-content-panel">
              <Suspense fallback={<div>Loading...</div>}>
                <Switch>
                  <Route
                    path="/login"
                    render={() =>
                      isLogin() ? (
                        <Redirect to="/dashboard" />
                      ) : (
                        <LoginComponent setPermissions={setPermissions} />
                      )
                    }
                  />
                  {routesConfig.map(({ path, Component, children }) => {
                    if (children && children.length > 0) {
                      return children.map(({ path, Component, children }) => {
                        if (children && children.length > 0) {
                          return children.map(({ path, Component }) => {
                            return (
                              <Route
                                key={path}
                                exact
                                path={path}
                                component={Component}
                              />
                            );
                          });
                        }

                        return (
                          <Route
                            key={path}
                            exact
                            path={path}
                            component={Component}
                          />
                        );
                      });
                    }

                    return (
                      <Route
                        key={path}
                        exact
                        path={path}
                        component={Component}
                      />
                    );
                  })}
                  <Route path="*">
                    <Result
                      status="404"
                      title="404"
                      subTitle="Sorry, the page you visited does not exist."
                      extra={
                        <Link to="/dashboard">
                          <Button type="primary" icon={<LeftOutlined />}>
                            Back to Dashboard
                          </Button>
                        </Link>
                      }
                    />
                  </Route>
                </Switch>
              </Suspense>
            </div>
          </Content>

          <Footer className="app-footer">
            Admin 3.0 ©{new Date().getFullYear()} Created by QMarketz Corp
            <span className="app-footer-sep">·</span>
            <a href="https://automart.ph">Automart.PH</a>
          </Footer>
        </Layout>
      </Layout>
      <ProfileDrawerComponent visible={showDrawer} onClose={showProfile} />
    </Router>
  );
};

const ActiveMenu = ({
  collapsed,
  toggle,
  handleClick,
  reviewIndexHasAccess,
  reviewGroupHasAccess,
  remarksSubGroupHasAccess,
  remarksIndexHasAccess,
  rolesRestriction,
  CLOSE_AUCTIONS_BY_FILE,
  CLOSE_AUCTIONS_BY_BANK,
  onShowProfile,
  onLogout,
}) => {
  const location = useLocation();
  const isMobile = useIsMobile();

  return (
    <Sider
      className="app-sider"
      theme="light"
      breakpoint="lg"
      collapsible
      collapsed={collapsed}
      onCollapse={toggle}
      width={248}
      collapsedWidth={isMobile ? 0 : 72}
    >
      <div className="app-brand" data-testid="app-brand">
        <img className="app-brand-logo" src={logo} alt="Automart" />
        {!collapsed && (
          <div className="app-brand-text">
            <span className="app-brand-name">Admin 3.0</span>
            <span className="app-brand-sub">Automart</span>
          </div>
        )}
      </div>
      <Menu
        className="app-menu"
        theme="light"
        mode="inline"
        selectedKeys={[location.pathname]}
        defaultOpenKeys={[]}
        onClick={handleClick}
      >
        <Menu.ItemGroup key="grp-overview" title="Overview">
        <Menu.Item key="/dashboard" icon={<PieChartOutlined />}>
          <Link to="/dashboard">Dashboard</Link>
        </Menu.Item>
        <Menu.Item key="/nps" icon={<PieChartOutlined />}>
          <Link to="/nps">NPS</Link>
        </Menu.Item>
        </Menu.ItemGroup>

        <Menu.ItemGroup key="grp-management" title="Management">
        <SubMenu
          key="sub-administration"
          icon={<UserOutlined />}
          title="Administration"
        >
          <Menu.Item key="/administration/platform">
            <Link to="/administration/platform">Platform</Link>
          </Menu.Item>
          <Menu.Item key="/administration/modules">
            <Link to="/administration/modules">Modules</Link>
          </Menu.Item>
          <Menu.Item key="/administration/permission-index">
            <Link to="/administration/permission-index">Permission Index</Link>
          </Menu.Item>
          <Menu.Item key="/administration/roles-access">
            <Link to="/administration/roles-access">Roles Access</Link>
          </Menu.Item>
          <Menu.Item key="/administration/user-management">
            <Link to="/administration/user-management">User Management</Link>
          </Menu.Item>
          <Menu.Item key="/administration/adviser-management">
            <Link to="/administration/adviser-management">Advisers</Link>
          </Menu.Item>
        </SubMenu>

        <Menu.Item key="/warehouses" icon={<HomeOutlined />}>
          <Link to="/warehouses">Warehouse</Link>
        </Menu.Item>
        <Menu.Item key="/providers" icon={<BankOutlined />}>
          <Link to="/providers">Providers</Link>
        </Menu.Item>

        </Menu.ItemGroup>

        <Menu.ItemGroup key="grp-content" title="Content">
        <SubMenu key="sub-cms" title="CMS" icon={<BuildOutlined />}>
          <Menu.Item key="/cms/pages">
            <Link to="/cms/pages">Pages</Link>
          </Menu.Item>
          <Menu.Item key="/cms/posts">
            <Link to="/cms/posts">Posts</Link>
          </Menu.Item>
          <Menu.Item key="/cms/assets">
            <Link to="/cms/assets">Manage Assets</Link>
          </Menu.Item>
          <Menu.Item key="/cms/post/sub-contents">
            <Link to="/cms/post/sub-contents">Post Contents</Link>
          </Menu.Item>
          <SubMenu key="sub-faq" title="FAQ's">
            <Menu.Item key="/faq/group">
              <Link to="/faq/group">FAQ Group</Link>
            </Menu.Item>
            <Menu.Item key="/faq/index">
              <Link to="/faq/index">FAQ Index</Link>
            </Menu.Item>
          </SubMenu>
          {remarksSubGroupHasAccess && remarksIndexHasAccess ? (
            <SubMenu key="sub-remarks" title="Pros & Cons">
              <Menu.Item key="/remarks/index" hidden={!remarksIndexHasAccess}>
                <Link to="/remarks/index">Pros & Cons Index</Link>
              </Menu.Item>
              <Menu.Item
                key="/remarks/group"
                hidden={!remarksSubGroupHasAccess}
              >
                <Link to="/remarks/group">Pros & Cons Group</Link>
              </Menu.Item>
            </SubMenu>
          ) : null}
        </SubMenu>

        {reviewIndexHasAccess && reviewGroupHasAccess ? (
          <SubMenu key="sub-reviews" title="Reviews" icon={<BuildOutlined />}>
            <Menu.Item
              key="/reviews"
              hidden={!reviewIndexHasAccess}
              icon={<BuildOutlined />}
            >
              <Link to="/reviews">Reviews Index</Link>
            </Menu.Item>
            <Menu.Item
              key="/reviews-group"
              hidden={!reviewGroupHasAccess}
              icon={<BuildOutlined />}
            >
              <Link to="/reviews-group">Reviews Group</Link>
            </Menu.Item>
          </SubMenu>
        ) : null}

        </Menu.ItemGroup>

        <Menu.ItemGroup key="grp-operations" title="Operations">
        <SubMenu
          key="sub-auctions"
          title="Auctions"
          icon={<DollarCircleOutlined />}
        >
          <Menu.Item
            key="/auctions/biddings-winner"
            style={{ display: 'none' }}
          >
            <Link to="/auctions/biddings-winner">Bidding Winners</Link>
          </Menu.Item>
          <Menu.Item key="/auctions/reports-v2">
            <Link to="/auctions/reports-v2">Bidding</Link>
          </Menu.Item>
          <Menu.Item key="/auctions/buynow-winner">
            <Link to="/auctions/buynow-winner">Buy Now Winners</Link>
          </Menu.Item>
          <Menu.Item
            key="/auctions/closer"
            hidden={
              CLOSE_AUCTIONS_BY_FILE === 0 && CLOSE_AUCTIONS_BY_BANK === 0
            }
          >
            <Link to="/auctions/closer">Auction Closer</Link>
          </Menu.Item>
        </SubMenu>

        <Menu.Item key="/bulk-uploader" icon={<CloudUploadOutlined />}>
          <Link to="/bulk-uploader">Bulk Uploader</Link>
        </Menu.Item>
        <Menu.Item key="/financing-uploader" icon={<CloudUploadOutlined />}>
          <Link to="/financing-uploader">Financing Uploader</Link>
        </Menu.Item>
        <Menu.Item key="/ads" icon={<FileDoneOutlined />}>
          <Link to="/ads">Ads</Link>
        </Menu.Item>
        <Menu.Item key="/orders" icon={<SendOutlined />}>
          <Link to="/orders">Order</Link>
        </Menu.Item>
        </Menu.ItemGroup>

        <Menu.ItemGroup key="grp-system" title="System">
        <Menu.Item
          key="/settings"
          icon={<SettingOutlined />}
          disabled={rolesRestriction.FULL_ACCESS_SETTINGS === 0}
        >
          <Link to="/settings">Settings</Link>
        </Menu.Item>

        <SubMenu
          key="sub-item-settings"
          title="Item Settings"
          icon={<SettingFilled />}
        >
          <Menu.Item key="/item/makes">
            <Link to="/item/makes">Makes</Link>
          </Menu.Item>
          <Menu.Item key="/item/models">
            <Link to="/item/models">Models</Link>
          </Menu.Item>
          <Menu.Item key="/item/vehicle-types">
            <Link to="/item/vehicle-types">Vehicle Types</Link>
          </Menu.Item>
          <Menu.Item key="/item/colors">
            <Link to="/item/colors">Colors</Link>
          </Menu.Item>
        </SubMenu>

        <Menu.Item key="/activity" icon={<BuildOutlined />}>
          <Link to="/activity">Activity Logs</Link>
        </Menu.Item>
        <Menu.Item key="/active-sessions" icon={<BuildOutlined />}>
          <Link to="/active-sessions">Sessions</Link>
        </Menu.Item>
        </Menu.ItemGroup>
      </Menu>

      <div className="app-user" data-testid="app-user">
        <Tooltip title="View profile" placement="right">
          <button
            type="button"
            className="app-user-profile"
            onClick={onShowProfile}
            data-testid="app-user-profile"
          >
            <Avatar className="app-avatar" size={32} icon={<UserOutlined />} />
            {!collapsed && (
              <span className="app-user-text">
                <span className="app-user-name">
                  {localStorage.getItem('name')}
                </span>
                <span className="app-user-role">
                  {localStorage.getItem('role_name')}
                </span>
              </span>
            )}
          </button>
        </Tooltip>
        {!collapsed && (
          <Tooltip title="Log out" placement="top">
            <button
              type="button"
              className="app-icon-button"
              onClick={onLogout}
              aria-label="Log out"
              data-testid="app-logout"
            >
              <LogoutOutlined />
            </button>
          </Tooltip>
        )}
      </div>
    </Sider>
  );
};
